/**
 * Zoned wall-clock → absolute instant. The worker fires calls against absolute
 * instants (§3 "T₀ never blocks on a DB query"), so the brain must convert the
 * solver's "minutes from local midnight" into a correct, DST-aware UTC instant
 * at compile time. No dependency — uses Intl to read the zone's offset.
 */
/** Offset (ms) such that localWallClock = utc + offset, at the given instant. */
function tzOffsetMs(utcMs, tz) {
    const dtf = new Intl.DateTimeFormat("en-US", {
        timeZone: tz,
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
    });
    const parts = dtf.formatToParts(new Date(utcMs));
    const m = {};
    for (const p of parts)
        if (p.type !== "literal")
            m[p.type] = Number(p.value);
    const asUTC = Date.UTC(m.year, m.month - 1, m.day, m.hour, m.minute, m.second);
    return asUTC - utcMs;
}
/**
 * Convert a local date + minutes-from-midnight (may be negative or >1440) in the
 * given IANA timezone to an ISO-8601 UTC instant string with offset (Z).
 */
export function zonedWallToInstant(localDate, minutesFromMidnight, tz) {
    const [y, mo, d] = localDate.split("-").map(Number);
    // baseUTC = the epoch if the wall time were read as UTC.
    const baseUTC = Date.UTC(y, mo - 1, d, 0, 0, 0) + minutesFromMidnight * 60_000;
    // True instant = baseUTC − offset. Iterate twice to settle across DST edges.
    let instant = baseUTC;
    for (let i = 0; i < 2; i++) {
        const off = tzOffsetMs(instant, tz);
        instant = baseUTC - off;
    }
    return new Date(instant).toISOString();
}
//# sourceMappingURL=zoned.js.map